<template>
  <div class="clearfix">
    <el-container>
      <el-header>
        <router-link to="/admin/index" tag="a" class="el-a">石家庄飞天科技</router-link>
        <el-button type="info" @click="logout">退出登陆</el-button>
      </el-header>
    </el-container>
    <el-aside width="200px">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        :router="true"
      >
        <el-menu-item v-for="item in menu" :key="item.id" :index="item.site">
          <i class="el-icon-menu"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <router-view class="main"></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        menu: [
          {id: 1, title: '栏目管理', site: '/admin/index/menu'},
          {id: 2, title: '案例管理', site: '/admin/index/case'},
          {id: 3, title: '文章管理', site: '/admin/index/article'},
          // {id:4,title:'留言管理',site:'/admin/index/leaveword'},
          {id: 5, title: '修改密码', site: '/admin/index/changepwd'},
          {id: 6, title: '关键字管理', site: '/admin/index/keywords'},
        ]
      };
    },
    created() {
      var tokens = window.sessionStorage.getItem('token')
      if (tokens == null) {
        this.$router.push('/admin/')
      }
    },
    methods: {
      async logout() {
        var dt = await this.$axios.post("/api/quit");
        console.log(JSON.parse(dt.data))
        dt.data = JSON.parse(dt.data)
        console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          } else {
            this.$message({
              message: '退出成功！',
              type: 'success'
            });
          }
        } else {
          alert(dt.statusText)
          return;
        }
        window.sessionStorage.removeItem("token");
        this.$router.push("/admin/");
      },
    },
  };
</script>

<style lang="less" scoped>
  .el-container {
    display: block;

    .el-header {
      background-color: rgb(67, 74, 80);
      color: #fff;
      line-height: 60px;

      .el-button {
        float: right;
        margin: 10px;
      }

      .el-a {
        font-size: 18px;
        color: #fff;
        font-weight: bold;
      }
    }
  }

  .el-aside {
    background-color: rgb(84, 92, 100);
    color: #333;
    text-align: center;
    line-height: 200px;
    font-size: 16px;
    min-height: 2000px;
    width: 10% !important;
    float: left;

    .el-main {
      background-color: #e9eef3;
      color: #333;

      .el-button--info {
        background: rgb(60, 70, 70);
        border-color: rgb(60, 70, 70);
        float: right;
        margin: 10px;

        .el-menu-vertical-demo {
          width: 100%;
        }
      }
    }
  }

  .main {
    width: 90%;
    float: left;
    padding: 30px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/index.vue